import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServicesIntro from "./sections/ServicesIntro";
import ServiceCategories from "./sections/ServiceCategories";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import AccountingBookkeeping from "./sections/AccountingBookkeeping";
import TaxPlanningAndAdvisory from "./sections/TaxPlanningAndAdvisory";
import PayrollServices from "./sections/PayrollServices";
import FinancialConsulting from "./sections/FinancialConsulting";
import BusinessFormation from "./sections/BusinessFormation";
import StrategicPlanning from "./sections/StrategicPlanning";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServicesIntro />
      <ServiceCategories />
      <AccountingBookkeeping />
      <TaxPlanningAndAdvisory />
      <PayrollServices />
      <FinancialConsulting />
      <BusinessFormation />
      <StrategicPlanning />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}